export default __webpack_public_path__ + "static/media/mask11.b1ab6f88.jpeg";